var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import styled from "styled-components";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { ETeam } from "../../../../types";
import { selectMatchState, setMatchState } from "../../../../store/match";
import { useAppDispatch, useAppSelector, useQuery } from "../../../../hooks";
import { useErrorHandler } from "../../../../hooks/useErrorHandler";
import { DeskPool } from "../../DeskPool";
import { ModalNew } from "../../../atoms/Modal/Modal";
import { Delimiter } from "../../../atoms/Delimiter";
import { setSheriffSuccess } from "../../../../api";
const eventStyles = {
    padding: "40px 48px",
    display: "flex",
    justifyContent: "space-between",
    width: "534px",
    alignContent: "baseline",
};
const Container = styled.div `
  display: flex;
  align-items: left;
  flex-direction: column;
`;
const ResultSpan = styled.span `
  color: ${({ green }) => (green ? "#66FB4D" : "#FD7D6B")};
`;
export function SheriffCheckResult() {
    const { param: matchId } = useQuery("matchId");
    const { errorHandler } = useErrorHandler(matchId);
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const [isRequestSent, setRequestSent] = useState(false);
    const result = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state) || [], [matchState]);
    const matchStateId = (matchState === null || matchState === void 0 ? void 0 : matchState.id) || "";
    const completeStep = () => __awaiter(this, void 0, void 0, function* () {
        if (isRequestSent)
            return;
        try {
            setRequestSent(true);
            const result = yield setSheriffSuccess(matchStateId);
            dispatch(setMatchState(result));
            setRequestSent(false);
        }
        catch (err) {
            errorHandler(err);
            setRequestSent(false);
        }
    });
    const buttonText = "Шериф увидел результат";
    // eslint-disable-next-line react/no-unstable-nested-components
    function PhaseEventModal() {
        return (_jsx(ModalNew, Object.assign({ eventModal: true, onClose: () => null }, { children: _jsx(Paper, Object.assign({ sx: eventStyles }, { children: _jsxs(Container, { children: [_jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0428\u0435\u0440\u0438\u0444\u0430" })), _jsx(Delimiter, { top: "10px" }), _jsxs("div", { children: [_jsxs(Typography, Object.assign({ variant: "h4" }, { children: ["\u041A\u043E\u0433\u043E \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u043B\u0438:", " ", _jsxs(ResultSpan, Object.assign({ green: result.target.team === ETeam.CIVILIANS }, { children: [`${result.target.name} (${result.target.role} - `, result.target.team === ETeam.MAFIA ? "Мафия" : "Мирный", ")"] }))] })), _jsx(Delimiter, { top: "15px" }), _jsxs(Typography, Object.assign({ variant: "h4" }, { children: ["\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438:", " ", _jsx(ResultSpan, Object.assign({ green: result.check.result === ETeam.CIVILIANS }, { children: result.check.result === ETeam.MAFIA ? "Мафия" : "Мирный" }))] }))] })] }) })) })));
    }
    const onPlayerClickAction = null;
    const gameButtonState = {
        text: buttonText,
        visible: true,
        onClick: () => completeStep(),
    };
    return (_jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState, addOnComponent: () => PhaseEventModal() }));
}
